import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid,
  ApexNonAxisChartSeries,
  ApexXAxis,
  ApexFill
} from "ng-apexcharts";

import { ActivitiesHeader, ChartRevenue, DashboardActivities, DashboardGolfMember, 
  DashboardGolfMemberResponse, DashboardHotelOccupancy, DashboardOfficeLease, 
  DashboardRevenue, Meta } from '../../core/models/dashboard';

import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../core/services/dashboard.service';
import { PieChartComponent } from '../../core/pie-chart/pie-chart.component';
import { PieChartService } from '../../core/pie-chart/pie-chart.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;  // Hapus union type dengan undefined
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};

interface CategoryColor {
  category: string;
  color: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
})

export class DashboardComponent implements OnInit {
  @ViewChild("chart") chart!: ChartComponent;
  @ViewChild('pieChart') pieChart!: PieChartComponent;

  public chartOptionsOccupancy!: ChartOptions;
  public chartOptionsOfficeLease!: ChartOptions;

  isLoading = false;
  ItemOccupancy: DashboardHotelOccupancy = {} as DashboardHotelOccupancy;
  ItemOfficeLease: DashboardOfficeLease = {} as DashboardOfficeLease;
  ItemGolfMember: DashboardGolfMember = {} as DashboardGolfMember;
  ItemRevenue: DashboardRevenue = {} as DashboardRevenue;
  ItemSalesActivites: DashboardActivities = {} as DashboardActivities;
  ItemHeaders: ActivitiesHeader[] = []

  metaData: Meta = {} as Meta;
  chartRevenue: ChartRevenue[] = []

  startDate: string = '';
  endDate: string = '';

  // Properties untuk limit data
  displayLimit: number = 10;
  showAllData: boolean = false;

  // Copy baseColors dari pie-chart untuk konsistensi
  private readonly baseColors = [
    '#1B5E20', '#B6D1C1', '#E8F5E9', '#4CAF50', '#81C784', '#A5D6A7', '#C8E6C9'
  ];

  // Properties untuk filter
  selectedFilter: string = '';

  // Object untuk menyimpan mapping warna kategori
  categoryColors: { [key: string]: string } = {};

  // Data dashboard
  dashboardData: any = null;
  hasError: boolean = false;
  errorMessage: string = '';

  // Loading states
  isLoadingOccupancy = false;
  isLoadingOfficeLease = false;

  
  expandedStates: boolean[] = [];
  isTotalExpanded: boolean = false;

    // Index untuk setiap section
  totalIndex: number = -1;
  hotelIndex: number = -1;
  residenceIndex: number = -1;
  officeIndex: number = -1;
  golfIndex: number = -1;
  
  findSectionIndexes() {
    console.log('Total items di chartRevenue:', this.chartRevenue.length);
    
    // Reset semua index ke -1 dulu
    this.totalIndex = -1;
    this.hotelIndex = -1;
    this.residenceIndex = -1;
    this.officeIndex = -1;
    this.golfIndex = -1;
    
    // Cari index setiap section
    this.chartRevenue.forEach((item, idx) => {
      console.log(`Item ${idx}:`, item.name);
      switch(item.name) {
        case 'Total Revenue': this.totalIndex = idx; break;
        case 'Hotel': this.hotelIndex = idx; break;
        case 'Residence': this.residenceIndex = idx; break;
        case 'Office Lease': this.officeIndex = idx; break;
        case 'Golf': this.golfIndex = idx; break;
      }
    });

    // 🔥 Ubah dari fill(false) menjadi fill(true)
    this.expandedStates = new Array(this.chartRevenue.length).fill(false); // ✅ SEMUA EXPANDED
    
    // 🔥 Set isTotalExpanded menjadi true juga
    this.isTotalExpanded = false;
  }  



  // Panggil fungsi ini setelah data revenueItem LOADED/DITERIMA
  

  // Array kategori yang akan ditampilkan di legend (akan di-update secara dinamis)
  legendCategories: { name: string; key: string }[] = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: DashboardService,
    private pieChartService: PieChartService
  ) { }

  ngOnInit(): void {
    const startDate = localStorage.getItem('startDate');
    const endDate = localStorage.getItem('endDate');

    this.startDate = startDate ? startDate : '';
    this.endDate = endDate ? endDate : '';

    // Load tanggal dari localStorage jika ada
    this.loadDatesFromStorage();

    // Load dashboard data dengan proper sequencing
    this.loadAllDashboardData();

  }

  private loadAllDashboardData(): void {
    // Load semua data dashboard
    this.loadDashboardOccupancy();
    this.loadDashboardOfficeLease();
    this.loadDashboardRevenue();
    this.loadDashboardGolfMember();
    this.loadDashboardActivities();
    this.loadDashboardData();
  }

  private loadDatesFromStorage(): void {
    const startDate = localStorage.getItem('startDate');
    const endDate = localStorage.getItem('endDate');

    this.startDate = startDate ? startDate : '';
    this.endDate = endDate ? endDate : '';
  }

  private loadDashboardData(): void {
    this.isLoading = true;
    this.hasError = false;

    this.pieChartService.getDashboardGolfMember(this.startDate, this.endDate).subscribe({
      next: (response: DashboardGolfMemberResponse) => {
        if (response.success && response.data) {
          this.dashboardData = response.data;

          // Update legend categories berdasarkan data yang diterima
          this.updateLegendCategories(response.data.chart);
        } else {
          this.handleError('No data available');
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading dashboard data:', error);
        this.handleError('Failed to load dashboard data. Please try again.');
        this.isLoading = false;
      }
    });
  }

  private updateLegendCategories(chartData: any[]): void {
    // Generate legend categories berdasarkan data dari API
    this.legendCategories = chartData.map(item => ({
      name: item.label,
      key: item.label.toLowerCase().trim()
    }));
  }

  private handleError(message: string): void {
    this.hasError = true;
    this.errorMessage = message;
    this.dashboardData = null;
  }

  // Method yang dipanggil ketika pie-chart mengirim color mapping
  onColorsGenerated(colorMapping: CategoryColor[]): void {
    console.log('Received color mapping:', colorMapping);

    // Reset categoryColors
    this.categoryColors = {};

    // Mapping warna berdasarkan kategori
    colorMapping.forEach(item => {
      // Normalize category name untuk matching
      const normalizedCategory = item.category.toLowerCase().trim();
      this.categoryColors[normalizedCategory] = item.color;

      // Debug log untuk setiap mapping
      console.log(`Mapped: "${normalizedCategory}" -> ${item.color}`);
    });

    console.log('Final category colors mapping:', this.categoryColors);

    // Force change detection jika diperlukan
    // this.cdr.detectChanges();
  }

  // Method untuk mendapatkan warna berdasarkan nama kategori
  getCategoryColor(categoryKey: string): string {
    const normalizedKey = categoryKey.toLowerCase().trim();
    const color = this.categoryColors[normalizedKey];

    console.log(`Getting color for "${normalizedKey}": ${color || '#cccccc (default)'}`);

    return color || '#cccccc'; // Default gray jika tidak ditemukan
  }

  // Method sederhana untuk mendapatkan background color berdasarkan baseColors
  getBoxBackgroundColor(categoryKey: string): string {
    // Cari index kategori dalam legendCategories
    const categoryIndex = this.legendCategories.findIndex(
      cat => cat.key.toLowerCase() === categoryKey.toLowerCase()
    );

    if (categoryIndex !== -1 && this.pieChart) {
      // Ambil warna dari baseColors berdasarkan index
      return this.pieChart.getColorByIndex(categoryIndex);
    }

    // Fallback - gunakan baseColors secara langsung jika pie chart belum ready
    const baseColors = [
      '#1B5E20', '#B6D1C1', '#E8F5E9', '#4CAF50', '#81C784', '#A5D6A7', '#C8E6C9'
    ];

    return categoryIndex !== -1 ? baseColors[categoryIndex % baseColors.length] : '#cccccc';
  }

  // Method untuk mendapatkan style object untuk box
  getBoxStyle(categoryKey: string): { [key: string]: string } {
    return {
      'background-color': this.getCategoryColor(categoryKey),
      'width': '20px',
      'height': '20px',
      'border-radius': '3px',
      'margin-right': '10px',
      'flex-shrink': '0'
    };
  }

  // Method untuk refresh data (bisa dipanggil saat date range berubah)
  refreshData(startDate?: string, endDate?: string): void {
    if (startDate !== undefined) this.startDate = startDate;
    if (endDate !== undefined) this.endDate = endDate;

    // Update localStorage
    localStorage.setItem('startDate', this.startDate);
    localStorage.setItem('endDate', this.endDate);

    // Reload data
    this.loadDashboardData();

    // Refresh pie chart data
    if (this.pieChart) {
      this.pieChart.refreshData(this.startDate, this.endDate);
    }
  }

  // Method untuk force sync colors (untuk debugging)
  forceSyncColors(): void {
    if (this.pieChart) {
      console.log('Force syncing colors...');
      this.pieChart.emitCurrentColors();
    }
  }

  // Method untuk debug - check current state
  debugColorState(): void {
    console.log('=== DEBUG COLOR STATE ===');
    console.log('Legend Categories:', this.legendCategories);
    console.log('Category Colors:', this.categoryColors);
    console.log('Pie Chart Component:', this.pieChart);

    this.legendCategories.forEach(category => {
      const color = this.getCategoryColor(category.key);
      console.log(`Legend "${category.name}" (${category.key}) -> ${color}`);
    });
  }

  // Method untuk format angka jika diperlukan
  formatNumber(value: number): string {
    return new Intl.NumberFormat('id-ID').format(value);
  }

  // Method untuk format persentase jika diperlukan
  formatPercentage(value: number): string {
    return `${value.toFixed(1)}%`;
  }

  loadDashboardOccupancy(): void {
    this.isLoadingOccupancy = true; // Gunakan loading state khusus untuk occupancy

    this.service.getDashboardOccupancy(
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.ItemOccupancy = response.data;
        this.metaData = response.meta;

        // Inisialisasi chart setelah data berhasil dimuat
        if (response.data.chart && response.data.max_pct_value) {
          this.initChartDataOccupancy(response.data.chart, response.data.max_pct_value);
        }

        this.isLoadingOccupancy = false;
      },
      error: (error) => {
        console.error('Error loading Occupancy data:', error);
        this.ItemOccupancy = {} as DashboardHotelOccupancy;

        // Inisialisasi chart dengan data kosong jika error
        this.initChartDataOccupancy([], 100);

        this.isLoadingOccupancy = false;
      }
    });
  }

  loadDashboardOfficeLease(): void {
    this.isLoadingOfficeLease = true; // Gunakan loading state khusus untuk office lease

    this.service.getDashboardOfficeLease(
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.ItemOfficeLease = response.data;
        this.metaData = response.meta;

        // Inisialisasi chart setelah data berhasil dimuat
        if (response.data.chart && response.data.max_pct_value) {
          this.initChartDataOfficeLease(response.data.chart, response.data.max_pct_value);
        }

        this.isLoadingOfficeLease = false;
      },
      error: (error) => {
        console.error('Error loading Office Lease data:', error);
        this.ItemOfficeLease = {} as DashboardOfficeLease;

        // Inisialisasi chart dengan data kosong jika error
        this.initChartDataOfficeLease([], 100);

        this.isLoadingOfficeLease = false;
      }
    });
  }

  loadDashboardRevenue(): void {
    this.isLoading = true;

    this.service.getDashboardRevenue(
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.ItemRevenue = response.data;
        this.metaData = response.meta;
        this.chartRevenue = response.data.chart
        // console.log(this.chartRevenue);

        this.isLoading = false;
        this.findSectionIndexes();
      },
      error: (error) => {
        console.error('Error loading revenue data:', error);
        this.isLoading = false;
        this.ItemRevenue = {} as DashboardRevenue;
      }
    });
  }

  loadDashboardGolfMember(): void {
    this.isLoading = true;

    this.service.getDashboardGolfMember(
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.ItemGolfMember = response.data;
        this.metaData = response.meta;
        // console.log(this.ItemGolfMember);

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading golf member data:', error);
        this.isLoading = false;
        this.ItemGolfMember = {} as DashboardGolfMember;
      }
    });
  }

  loadDashboardActivities(): void {
    this.isLoading = true;

    this.service.getDashboardSalesActivities(
      this.startDate,
      this.endDate,
      this.selectedFilter
    ).subscribe({
      next: (response) => {
        this.ItemSalesActivites = response.data;
        this.metaData = response.meta;

        // Reset show all data ketika load data baru
        this.showAllData = false;

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading Sales Activities data:', error);
        this.isLoading = false;
        this.ItemSalesActivites = {} as DashboardActivities;
      }
    });
  }

  // Method untuk handle click category button
  onCategoryClick(categoryValue: any): void {
    // Jika category yang sama diklik lagi, reset filter (show all)
    if (this.selectedFilter === categoryValue) {
      this.selectedFilter = '';
    } else {
      this.selectedFilter = categoryValue;
    }

    // Reset pagination
    this.showAllData = false;

    // Load data dengan filter baru
    this.loadDashboardActivities();
  }

  // Method untuk cek apakah category button active
  isCategoryActive(categoryValue: string): boolean {
    return this.selectedFilter === categoryValue;
  }

  // Method untuk mendapatkan data yang akan ditampilkan
  getDisplayedData(): any[] {
    if (!this.ItemSalesActivites.chart) {
      return [];
    }

    if (this.showAllData) {
      return this.ItemSalesActivites.chart;
    }

    return this.ItemSalesActivites.chart.slice(0, this.displayLimit);
  }

  // Method untuk cek apakah perlu tampilkan tombol "Show More"
  shouldShowMoreButton(): boolean {
    if (!this.ItemSalesActivites.chart) {
      return false;
    }

    return this.ItemSalesActivites.chart.length > this.displayLimit && !this.showAllData;
  }

  // Method untuk toggle show more
  toggleShowMore(): void {
    this.showAllData = !this.showAllData;
  }

  // Method untuk mendapatkan text tombol
  getShowMoreButtonText(): string {
    return this.showAllData ? 'Show Less' : 'Show More';
  }

  // Method untuk mendapatkan total data
  getTotalDataCount(): number {
    return this.ItemSalesActivites.chart ? this.ItemSalesActivites.chart.length : 0;
  }

  // Method untuk mendapatkan jumlah data yang sedang ditampilkan
  getDisplayedDataCount(): number {
    return this.getDisplayedData().length;
  }

  // Method untuk clear filter
  clearFilter(): void {
    this.selectedFilter = '';
    this.showAllData = false;
    this.loadDashboardActivities();
  }

  // Method untuk mendapatkan text filter status
  getFilterStatusText(): string {
    if (this.selectedFilter) {
      return `Filtered by: ${this.selectedFilter}`;
    }
    return 'All Activities';
  }


  private initChartDataOccupancy(chartData: any[], maxPercentage: any): void {
    // Pastikan chartData tidak undefined atau null
    const safeChartData = chartData || [];

    // Ekstrak value untuk series data
    const seriesData = safeChartData.map(item => item?.value || 0);

    // Ekstrak dan format date untuk xaxis categories
    const formattedDates = safeChartData.map(item => {
      return item?.label || '';
    });

    const yaxisMax = maxPercentage || 100;

    // Logika untuk warna - default semua #B6D1C1, yang terakhir #191919
    const xaxisLabelColors = Array(safeChartData.length).fill("#B6D1C1");
    if (safeChartData.length > 0) {
      xaxisLabelColors[safeChartData.length - 1] = "#191919";
    }

    this.chartOptionsOccupancy = {
      series: [{
        name: "Persentase",
        data: seriesData,
      }],
      chart: {
        height: 400,
        width: '100%',
        type: "bar",
        events: {
          click: function (event, chartContext, config) {
            const defaultColors = Array(safeChartData.length).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },

          mouseMove: function (event, chartContext, config) {
            const defaultColors = Array(safeChartData.length).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      },
      colors: Array(safeChartData.length).fill("#B6D1C1"),
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "60%",
          distributed: true,
          dataLabels: {
            position: 'end'
          }
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"
        },
        offsetX: 10,
        style: {
          fontSize: '12px',
          colors: ["#126936"],
          fontWeight: 'bold'
        },
        distributed: true,
      },
      legend: {
        show: false
      },
      grid: {
        show: true,
        position: 'back',
        borderColor: '#E6E6E6',
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: false,
          }
        },
        padding: {
          left: 20
        }
      },
      xaxis: {
        categories: formattedDates,
        labels: {
          formatter: function (val) {
            return val + "%";
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
            fontWeight: 'normal'
          }
        },
        min: 0,
        max: yaxisMax,
        tickAmount: 5,
        axisBorder: {
          show: true,
          color: "#E6E6E6"
        },
        axisTicks: {
          show: true,
          color: "#E6E6E6"
        },
        title: {
          text: ""
        },
        crosshairs: {
          show: false
        }
      },
      yaxis: {
        //categories: formattedDates,
        labels: {
          style: {
            colors: Array(formattedDates.length).fill("#B6D1C1"), //xaxisLabelColors,
            cssClass: 'apexcharts-yaxis-label',
            fontSize: "12px",
            fontWeight: 'bold'
          },
          offsetX: -10,
        },
      },
    };
  }

  private initChartDataOfficeLease(chartData: any[], maxPercentage: any): void {
    // Pastikan chartData tidak undefined atau null
    const safeChartData = chartData || [];

    // Ekstrak value untuk series data
    const seriesData = safeChartData.map(item => item?.value || 0);

    // Ekstrak dan format date untuk xaxis categories
    const formattedDates = safeChartData.map(item => {
      return item?.label || '';
    });

    const yaxisMax = maxPercentage || 100;

    // Logika untuk warna - default semua #B6D1C1, yang terakhir #191919
    const xaxisLabelColors = Array(safeChartData.length).fill("#B6D1C1");
    if (safeChartData.length > 0) {
      xaxisLabelColors[safeChartData.length - 1] = "#191919";
    }
    /*TW20251007
    this.chartOptionsOfficeLease = {
      series: [{
        name: "Persentase",
        data: seriesData,
      }],
      chart: {
        height: 400,
        width: '100%',
        type: "bar",
        events: {
          click: function (event, chartContext, config) {
            const defaultColors = Array(safeChartData.length).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },

          mouseMove: function (event, chartContext, config) {
            const defaultColors = Array(safeChartData.length).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      },
      colors: Array(safeChartData.length).fill("#B6D1C1"),
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          distributed: true,
          dataLabels: {
            position: 'top'
          }
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"
        },
        offsetY: -25,
        style: {
          fontSize: '12px',
          colors: ["#126936"],
          fontWeight: 'bold'
        },
        distributed: true,
      },
      legend: {
        show: false
      },
      grid: {
        show: true,
        position: 'back',
        borderColor: '#E6E6E6',
        xaxis: {
          lines: {
            show: false
          },
        },
        yaxis: {
          lines: {
            show: false,
          }
        },
        padding: {
          left: 20
        }
      },
      xaxis: {
        categories: formattedDates,
        labels: {
          rotate: -45,
          trim: false,
          hideOverlappingLabels: false,
          rotateAlways: true,
          style: {
            colors: xaxisLabelColors,
            cssClass: 'apexcharts-xaxis-label',
            fontSize: "12px",
            fontWeight: 'bold'
          },
          offsetY: 8,
          offsetX: 10
        },
        tickPlacement: 'on',
      },
      yaxis: {
        title: {
          text: ""
        },
        min: 0,
        max: yaxisMax,
        tickAmount: 5,
        labels: {
          formatter: function (val) {
            return val + "%"
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
            fontWeight: 'normal'
          },
          offsetX: 10
        },
        axisBorder: {
          show: true,
          color: "#E6E6E6"
        },
        axisTicks: {
          show: true,
          color: "#E6E6E6",
          width: 6,
          offsetX: 0
        },
        crosshairs: {
          show: false
        },
        opposite: false
      },
    };
    */
    this.chartOptionsOfficeLease = {
      series: [{
        name: "Persentase",
        data: seriesData,
      }],
      chart: {
        height: 400,
        width: '100%',
        type: "bar",
        events: {
          click: function (event, chartContext, config) {
            const defaultColors = Array(safeChartData.length).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },

          mouseMove: function (event, chartContext, config) {
            const defaultColors = Array(safeChartData.length).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      },
      colors: Array(safeChartData.length).fill("#B6D1C1"),
      plotOptions: {
        bar: {
          horizontal: true, // DIUBAH: false → true
          barHeight: "60%", // DIUBAH: columnWidth → barHeight
          distributed: true,
          dataLabels: {
            position: 'end' // DIUBAH: 'top' → 'end'
          }
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"
        },
        offsetX: 10, // DIUBAH: offsetY → offsetX
        style: {
          fontSize: '12px',
          colors: ["#126936"],
          fontWeight: 'bold'
        },
        distributed: true,
      },
      legend: {
        show: false
      },
      grid: {
        show: true,
        position: 'back',
        borderColor: '#E6E6E6',
        xaxis: {
          lines: {
            show: true, // DIUBAH: false → true
          },
        },
        yaxis: {
          lines: {
            show: false,
          }
        },
        padding: {
          left: 20
        }
      },
      xaxis: {
        categories: formattedDates, // DIUBAH: pindahkan categories dari xaxis ke yaxis
        labels: {
          formatter: function (val) {
            return val + "%";
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
            fontWeight: 'normal'
          }
        },
        min: 0,
        max: yaxisMax,
        tickAmount: 5,
        axisBorder: {
          show: true,
          color: "#E6E6E6"
        },
        axisTicks: {
          show: true,
          color: "#E6E6E6"
        },
        title: {
          text: ""
        },
        crosshairs: {
          show: false
        }
      },
      yaxis: {
        
        labels: {
          style: {
            colors: Array(formattedDates.length).fill("#B6D1C1"), //xaxisLabelColors,
            cssClass: 'apexcharts-yaxis-label', // DIUBAH: xaxis-label → yaxis-label
            fontSize: "12px",
            fontWeight: 'bold'
          },
          offsetX: -10, // DIUBAH: offset disesuaikan
        },
        // HAPUS property yang tidak diperlukan untuk yaxis horizontal:
        // title, min, max, tickAmount, axisBorder, axisTicks, crosshairs, opposite
      },
    };
  }

  // Method untuk refresh data (ketika filter tanggal berubah)
  public refreshDashboardData(): void {

    // Update localStorage jika diperlukan
    if (this.startDate) localStorage.setItem('startDate', this.startDate);
    if (this.endDate) localStorage.setItem('endDate', this.endDate);

    // Reload data
    this.loadDashboardOccupancy();
    this.loadDashboardOfficeLease();
  }
  getPercentageClass(percentage: number): string {
    if (percentage >= 100) {
      return 'badge custom-progress-success';
    }
    return 'badge custom-progress-danger';
  }

  toggleTotal() {
    console.log('=== TOGGLE TOTAL DIPANGGIL ===');
    console.log('Sebelum:', {
        isTotalExpanded: this.isTotalExpanded,
        expandedStates: [...this.expandedStates]
    });
    
    this.isTotalExpanded = !this.isTotalExpanded;
    
    console.log('Setelah toggle:', {
        isTotalExpanded: this.isTotalExpanded,
        akan_set_semua_ke: this.isTotalExpanded
    });
    
    // Expand/collapse semua section
    if (this.hotelIndex !== -1) {
        this.expandedStates[this.hotelIndex] = this.isTotalExpanded;
        console.log(`Hotel (index ${this.hotelIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.residenceIndex !== -1) {
        this.expandedStates[this.residenceIndex] = this.isTotalExpanded;
        console.log(`Residence (index ${this.residenceIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.officeIndex !== -1) {
        this.expandedStates[this.officeIndex] = this.isTotalExpanded;
        console.log(`Office (index ${this.officeIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.golfIndex !== -1) {
        this.expandedStates[this.golfIndex] = this.isTotalExpanded;
        console.log(`Golf (index ${this.golfIndex}) → ${this.isTotalExpanded}`);
    }
    
    console.log('Akhir:', {
        isTotalExpanded: this.isTotalExpanded,
        expandedStates: [...this.expandedStates]
    });
  }
  toggleExpand(index: number) {
    this.expandedStates[index] = !this.expandedStates[index];
  }
}
